<template>
  <v-app>

    <v-app-bar app color="primary" dense dark fixed>
      <v-app-bar-nav-icon @click.stop="navbar = !navbar"></v-app-bar-nav-icon>

      <v-app-bar-nav-icon>
        <img src="@/assets/logo.jpg" style="height: 32px;" alt="logo"/>
      </v-app-bar-nav-icon>
      <v-toolbar-title>
        RustBox - Leaderboard
      </v-toolbar-title>

      <v-spacer/>
      <v-icon class="pr-2">mdi-theme-light-dark</v-icon>
      <v-switch dense class="pt-5" v-model="darkMode"/>
    </v-app-bar>

    <v-navigation-drawer v-model="navbar" app bottom temporary>
      <v-list>
        <v-list-item>
          <v-list-item-title>RustBox.eu</v-list-item-title>
        </v-list-item>
      </v-list>
      <v-divider/>
      <v-list dense rounded>
        <v-list-item to="/" color="primary">
          <v-list-item-icon>
            <v-icon color="primary">mdi-account-outline</v-icon>
          </v-list-item-icon>
          <v-list-item-title>
            Leaderboard
          </v-list-item-title>
        </v-list-item>

        <v-list-item to="/clans" color="primary">
          <v-list-item-icon>
            <v-icon color="primary">mdi-account-group-outline</v-icon>
          </v-list-item-icon>
          <v-list-item-title>
            Clans
          </v-list-item-title>
        </v-list-item>
      </v-list>
    </v-navigation-drawer>

    <v-main class="pb-10">
      <router-view/>
    </v-main>

    <v-footer color="" dark fixed>
      Copyright 2021 by Rustbox | RustBox is not affiliated with FacePunch Studios or Rust.
    </v-footer>
  </v-app>
</template>

<style lang="scss">
@import url('https://fonts.googleapis.com/css2?family=Nunito:wght@400&display=swap');

#app {
  font-family: Nunito, Avenir, Helvetica, Arial, sans-serif;
  -webkit-font-smoothing: antialiased;
  -moz-osx-font-smoothing: grayscale;
}
</style>

<script>
export default {
  data: () => ({
    navbar: false,
    darkMode: true,
  }),
  mounted() {
    this.darkMode = window.localStorage.getItem('RustBoxEU_LeaderBoardTheme') !== 'LIGHT';
    this.$vuetify.theme.dark = this.darkMode;
  },
  watch: {
    darkMode: function (newVal) {
      window.localStorage.setItem('RustBoxEU_LeaderBoardTheme', newVal ? 'DARK' : 'LIGHT');
      this.$vuetify.theme.dark = newVal;
    }
  }
}
</script>
